<template>
  <div class="content" v-loading="loading">
    <el-button
      type="primary"
      class="mw-add-button"
      @click="dialogVisible = true"
      >新建控制策略</el-button
    >
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="title" label="策略名称"></el-table-column>
        <el-table-column label="类型">
          <template slot-scope="scope">
            {{scope.row.isConcentratorPlan?'集控策略':'回路策略'}}
          </template>
        </el-table-column>
        <el-table-column label="策略分配">
          <template slot-scope="scope">
            <i
              class="el-icon-upload2 pointer"
              @click="openSend(scope.row)"
              title="分配控制策略"
            ></i>
          </template>
        </el-table-column>
        <el-table-column label="是否启用">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.ste"
              :active-value="1"
              :inactive-value="0"
              active-color="#3ba631"
              inactive-color="#B9B9B9"
              @change="changeStates(scope.row.id,$event)"
              />
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <i
                class="el-icon-edit pointer mar-r10"
                @click="openEdit(scope.row)"
              ></i>
              <i class="el-icon-delete pointer" @click="delItem(scope.row.id)"></i>
          </template>
        </el-table-column>
      </el-table>


      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>

    <!-- 新增控制策略 -->
    <el-dialog
      class="big-dialog"
      title="新增控制策略"
      :visible.sync="dialogVisible"
      @close="closeAdd"
    >

      <add-foucus-strategy
        v-if="dialogVisible"
        ref="addStrategy" 
        @closeMethod="closeAdd"
      ></add-foucus-strategy>

    </el-dialog>

    <el-dialog
      class="big-dialog"
      title="修改控制策略"
      :visible.sync="editVisible"
      @close="closeEdit"
    >
      <edit-foucus-strategy
        v-if="editVisible"
        :editData="editData"
        ref="editStrategy"
        @closeMethod="closeEdit"
      ></edit-foucus-strategy>
    </el-dialog>

    <el-dialog
      class="dialog800"
      :title="'策略分配['+sendData.stg_name+']'"
      :visible.sync="sendVisible"
      v-if="sendVisible"
    >
      <send-foucus-strategy
        :sendData="sendData"
        ref="sendStrategy"
        @closeMethod="closeSend"
      ></send-foucus-strategy>
    </el-dialog>
  </div>
</template>
<script>
import strategyApi from "@/api/concentrator/strategy"
import addFoucusStrategy from "@/components/concentratorStrategys/addFoucusStrategy.vue"
import editFoucusStrategy from "@/components/concentratorStrategys/editFoucusStrategy.vue"
import sendFoucusStrategy from "@/components/concentratorStrategys/sendFoucusStrategy.vue"
export default {
  components: { 
    addFoucusStrategy,
    editFoucusStrategy,
    sendFoucusStrategy
  },
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 20,
      },
      cnt_all: 0,
      dialogVisible: false,
      editVisible: false,
      editData: {
        id: null,
        title: '',
        isConcentratorPlan: 1,
        loopPlan: null,
        concentratorPlan: null,
        ste: 0
      },
      sendVisible: false,
      sendData: {
        stg_id: null,
        stg_name: ''
      }
    };
  },
  methods: {
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex
      this.loading = true
      this.tableData = []
      strategyApi.strategyList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      })
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          strategyApi.strategyDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    openSend(value) {
      let sendParams = { 
        stg_id: value.id, 
        stg_name: value.title
      }
      this.sendVisible = true
      this.sendData = sendParams
    },
    closeSend() {
      this.sendVisible = false
      this.sendData = {
        stg_id: null,
        stg_name: ''
      }
      this.getTableData(this.pageInfo.page);
    },


    closeAdd() {
      this.dialogVisible = false
      this.getTableData(this.pageInfo.page);
    },
    openEdit(strategy) {
      const {id, title, isConcentratorPlan, loopPlan, concentratorPlan, ste} = strategy
      this.editData = strategy
      this.editData = {
        id,
        title,
        isConcentratorPlan,
        loopPlan,
        concentratorPlan,
        ste
      }
        
      this.editVisible = true
    },
    closeEdit() {
      this.editVisible = false
      this.editData = {
        id: null,
        title: '',
        isConcentratorPlan: 1,
        loopPlan: null,
        concentratorPlan: null,
        ste: 0
      }
      this.getTableData(this.pageInfo.page);
    },
   
    changeStates(id, value) { //禁用或启用集中控制器策略
      strategyApi.setStrategySte(id,{ ste: value }).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(res.data.message);
          this.getTableData(this.pageInfo.page);
        }else{
          this.$message.error(res.data.message);
        }
      });
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page)
  },
};
</script>

<style lang='less' scoped>
.pointer {
  cursor: pointer;
}
</style>
